import { AuthProvider } from './auth/AuthContext';
import AppRouter from './app/router';
import { ChatProvider } from './chat/ChatProvider';
import { ImFeatureProvider } from './im/ImFeatureProvider';
import { MiniChatProvider } from './mini-chat/MiniChatProvider';
import { TimeZoneProvider } from './context/TimeZoneContext';
import { LocaleProvider } from './i18n/LocaleContext';
import './styles/app.css';
import './styles/security.css';

function App() {
  return (
    <LocaleProvider>
      <TimeZoneProvider>
        <AuthProvider>
          <ImFeatureProvider>
            <ChatProvider>
              <MiniChatProvider>
                <AppRouter />
              </MiniChatProvider>
            </ChatProvider>
          </ImFeatureProvider>
        </AuthProvider>
      </TimeZoneProvider>
    </LocaleProvider>
  );
}

export default App;
